import e from"./WepinStorage.js";export default e;